import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77b0464a")

_pushScopeId("data-v-77b0464a")
const _hoisted_1 = { class: "order-steps-header" }
const _hoisted_2 = { class: "mobile-action-back" }
const _hoisted_3 = { class: "order-page-title" }
const _hoisted_4 = { class: "order-header-actions" }
const _hoisted_5 = { class: "desktop-actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: { 'order-steps-header-template': _ctx.boxShadow }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, [
          _createVNode("i", {
            class: "icon-f fs-20 icon-calendar-arrow-back px-3 arrows",
            style: {"cursor":"pointer"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back()))
          })
        ])
      ]),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            class: "desktop-actions-footer-cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.back())),
            type: "button"
          }, _toDisplayString(_ctx.backText ?? _ctx.$t('button.cancel')), 1),
          (_ctx.showSubmit)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "desktop-actions-footer-save",
                form: _ctx.formId,
                disabled: _ctx.formDisabled,
                type: "submit"
              }, _toDisplayString(_ctx.submitText ?? _ctx.$t('button.create')), 9, ["form", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
})